import _ from 'lodash'
import {GetterTree} from 'vuex'
import {SEOState} from '@/modules/seo/store'
import {RootState} from '@/store/types'

const getters: GetterTree<SEOState, RootState> = {

    /**
     * Devuelve la traducción que se encuentra en edición en el objeto de
     * meta-información del SEO actual
     *
     * @param state
     * @returns {MetadataTranslation}
     */
    'metadata/current/translation': (state) => state.currentMetadata.translate(state.currentLocale),

    /**
     * Comprueba si un campo ha sido modificado por el usuario
     */
    'metadata/field/isTouched': (state) => (locale: string, fieldName: string) => {
        return _.includes(state.touchedMetadataFields.get(locale) || [], fieldName)
    },
}

export default getters
